import PanelTitle from '../../common-components/panel/panel-title';
import { useAppSelector } from '../../hooks';
// TODO: remove HistoryForm and this import when DaaS endpoints are decommissioned
import HistoryFormAisApi from './history-form-ais-api/history-form-ais-api';
import HistoryForm from './history-form/history-form';

function HistoryPanel() {
  const { canAccessFeatureAisApiHistory } = useAppSelector(
    (state) => state.featureFlags.flags
  );

  return (
    <div className="history-panel-container">
      <PanelTitle>History</PanelTitle>
      {canAccessFeatureAisApiHistory.enabled ? (
        <HistoryFormAisApi />
      ) : (
        // TODO: remove this branch when DaaS endpoints are decommissioned
        <HistoryForm />
      )}
    </div>
  );
}

export default HistoryPanel;
